import { connect } from "react-redux";
import React, {PureComponent } from "react";
import { Dispatch } from "redux";
import Snackbar, { SnackbarOrigin } from "@material-ui/core/Snackbar";
import { clearSnack } from "../../../state/snackbar/operations";
import { SnackbarTypes } from "../../../state/snackbar/types";
import Alert from "@material-ui/lab/Alert";
import { Color } from "@material-ui/lab/Alert";
import { AppState } from "../../../state/store";

const mapStateToProps = (state: AppState) => {
  return {
    snackbarMessage: state.snackbarReducer.message,
    snackbarType: state.snackbarReducer.type,
    snackbarOpen: state.snackbarReducer.open,
  };
};

const mapDispatchToProps = (dispatch: Dispatch, props: {}) => {
  return {
    handleClear: () => clearSnack()(dispatch),
  };
};

type Props = Partial<ReturnType<typeof mapStateToProps>> &
  Partial<ReturnType<typeof mapDispatchToProps>>;

export class SnackBar extends PureComponent<Props> {
 
  private handleCloseSuccess = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason !== "clickaway") this.props.handleClear!();
  };

  private handleClose = () => {
    this.props.handleClear!();
  };
  
  private getAchor = {
    vertical: "bottom",
    horizontal: "center",
  } as SnackbarOrigin;

  private getType = (): Color => {
    if (this.props.snackbarType === SnackbarTypes.success) {
      return "success";
    } else if (this.props.snackbarType === SnackbarTypes.error) {
      return "error";
    } else if (this.props.snackbarType === SnackbarTypes.warning) {
      return "warning";
    } else return "info";
  };

  private getDuration = () => {
    if (this.props.snackbarType === SnackbarTypes.success) {
      return 4000;
    } else if (this.props.snackbarType === SnackbarTypes.error) {
      return 10000;
    } else if (this.props.snackbarType === SnackbarTypes.warning) {
      return 10000;
    } else if (this.props.snackbarType === SnackbarTypes.info) {
      return 10000;
    } else return 4000;
  };

  private determineAction = () => {
    if (this.props.snackbarType === SnackbarTypes.success) {
      return (
        <div>
          <Snackbar
            autoHideDuration={this.getDuration()}
            anchorOrigin={this.getAchor}
            open={this.props.snackbarOpen!}
            onClose={this.handleCloseSuccess}
          >
            <Alert severity={this.getType()}>
              {this.props.snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      );
    } else {
      return (
        <div>
          <Snackbar
            anchorOrigin={this.getAchor}
            open={this.props.snackbarOpen!}
          >
            <Alert severity={this.getType()} onClose={this.handleClose}>
              {this.props.snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      );
    }
  };

  public render() {
    return <div>{this.determineAction()}</div>;
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);
